module.exports = __webpack_public_path__ + "img/aws.5830aea3.svg";